import $ from 'jquery';
import { $root, $banner, $pageUserHero, $newsSelect, $contactSelect } from './variables';
import { loadmore_posts } from './ajax';
// @ts-ignore
import jQueryBridget from 'jquery-bridget';
import masonry from 'masonry-layout';

jQueryBridget('masonry', masonry, $);

if ($banner) {
  let margin_top = $banner.height() ?? 0;
  $pageUserHero.css('margin-top', margin_top);

  $('.js__banner_remove').on('click', () => {
    $banner.css('top', '-60px');
    $pageUserHero.css('margin-top', '');
    setTimeout(function () {
      $banner.remove();
    }, 500);
  })
}

if ($newsSelect.length) {
  $newsSelect.on('change', (event) => {
    let value = event.target.value;

    if (value !== "newest") {
      let class_selector = ".js__" + value;
      $('.post').addClass('hidden');
      $(class_selector).removeClass('hidden');
    } else {
      $('.post').removeClass('hidden');
    }

    $('.js__post_container').masonry();

    let visible_posts = $('.post').not('.hidden').length;

    if (visible_posts < 4) {
      loadmore_posts();
    }

    $root.animate({ scrollTop: '+=1px' }, 10);
  });
}

if ($contactSelect.length) {
  $contactSelect.on('change', (event) => {
    let value = event.target.value;
    let class_selector = "." + value;
    $('.contact-form-container').addClass('hidden');
    $(class_selector).removeClass('hidden');
  })
}